"use client";

import { RouteErrorBoundary } from "@/app/_components/ui/route-error-boundary";

export default function FrontDoorGroupError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteErrorBoundary boundary="(front-door)" error={error} reset={reset} />
  );
}
